// Shared by Store Settings and the region, team and pilot invite tabs it hosts.
export const CONSIGNMENT_BRANCH_SETTING_TAB = {
	Branches: "branches",
	Regions: "regions",
	Teams: "teams",
	PilotInvites: "pilot-invites",
} as const;

export type ConsignmentBranchSettingTab =
	(typeof CONSIGNMENT_BRANCH_SETTING_TAB)[keyof typeof CONSIGNMENT_BRANCH_SETTING_TAB];

export const CONSIGNMENT_BRANCH_SETTING_TAB_STORAGE_KEY =
	"consignment-branch-setting-tab";

export const CONSIGNMENT_BRANCH_SETTING_ACTION_SEARCH_KEY = "action";

export const CONSIGNMENT_BRANCH_SETTING_ACTION = {
	Create: "create",
	Import: "import",
} as const;

// Registration access as seen by the Pilot invites tab; Loading hides the actions until known.
export const REGISTRATION_ACCESS_STATE = {
	Loading: "loading",
	InviteOnly: "inviteOnly",
	OpenToEveryone: "openToEveryone",
} as const;

export type RegistrationAccessState =
	(typeof REGISTRATION_ACCESS_STATE)[keyof typeof REGISTRATION_ACCESS_STATE];
